import { ORG_SLUG } from '@wapharma/shared';

export type DeployOrgBrand = {
  slug: typeof ORG_SLUG.HAMSSAH;
  legalName: string;
  dataBrand: 'hamssah';
  logoOnDark: string;
  logoOnLight: string;
  defaultBrandTitle: string;
  loginTaglines: readonly string[];
};

const HAMSSAH_BRAND: DeployOrgBrand = {
  slug: ORG_SLUG.HAMSSAH,
  legalName: 'Hamssah',
  dataBrand: 'hamssah',
  logoOnDark: '/brand/main-logo.svg',
  logoOnLight: '/brand/main-logo-dark.svg',
  defaultBrandTitle: 'Administration retail',
  loginTaglines: [
    'Commandes, catalogue et showroom — un seul espace.',
    'Votre back-office retail Hamssah.',
    'Gérez la vitrine et le point de vente depuis ici.',
    'Beauté et parfumerie — opérations au quotidien.',
  ],
};

export function resolveDeployOrgBrand(): DeployOrgBrand {
  return HAMSSAH_BRAND;
}

export function pickLoginTagline(brand: DeployOrgBrand): string {
  const lines = brand.loginTaglines;
  return lines[Math.floor(Math.random() * lines.length)] ?? lines[0]!;
}

export function authFooterLine(brand: DeployOrgBrand): string {
  return `© ${new Date().getFullYear()} ${brand.legalName} · Réservé au personnel autorisé`;
}
